'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _lodashCollectionIncludes = require('lodash/collection/includes');

var _lodashCollectionIncludes2 = _interopRequireDefault(_lodashCollectionIncludes);

var _lodashArrayPull = require('lodash/array/pull');

var _lodashArrayPull2 = _interopRequireDefault(_lodashArrayPull);

var _cssMediaquery = require('css-mediaquery');

var _cssMediaquery2 = _interopRequireDefault(_cssMediaquery);

var _exenv = require('exenv');

var _exenv2 = _interopRequireDefault(_exenv);

var MediaQueryListMock = (function () {
  function MediaQueryListMock(query, getConfig) {
    _classCallCheck(this, MediaQueryListMock);

    this._getConfig = getConfig;
    this._query = query;
    this._listeners = [];
  }

  _createClass(MediaQueryListMock, [{
    key: 'matches',
    get: function () {
      return _cssMediaquery2['default'].match(this._query, this._getConfig());
    }
  }, {
    key: 'addListener',
    value: function addListener(listener) {
      if (!_exenv2['default'].canUseDOM) {
        return;
      }

      if (!_lodashCollectionIncludes2['default'](this._listeners, listener)) {
        this._listeners.push(listener);
      }
    }
  }, {
    key: 'removeListener',
    value: function removeListener(listener) {
      _lodashArrayPull2['default'](this._listeners, listener);
    }
  }, {
    key: 'callListeners',
    value: function callListeners() {
      var _this = this;

      this._listeners.forEach(function (listener) {
        return listener(_this);
      });
    }
  }]);

  return MediaQueryListMock;
})();

exports['default'] = MediaQueryListMock;
module.exports = exports['default'];
//# sourceMappingURL=MediaQueryListMock.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/match-media-mock/lib/MediaQueryListMock.js
// module id = 270
// module chunks = 0